import React from "react";
import { Check, IndianRupee, Sparkles } from "lucide-react";

const FEATURES = [
  "AI agent built from your resume",
  "Automated outreach & tailored proposals",
  "Auto-negotiation in ₹",
  "Payouts straight to UPI or bank",
  "Full control over rates & projects",
  "Cancel or pause anytime",
];

export default function Pricing() {
  const scrollToWaitlist = () => {
    const el = document.getElementById("waitlist");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="pricing" data-testid="pricing" className="py-24">
      <div className="mx-auto max-w-6xl px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-blue-600">Simple, fair pricing</p>
          <h2 className="mt-2 font-display text-3xl sm:text-4xl md:text-5xl font-black tracking-tight text-slate-900 leading-tight">
            Keep <span className="text-blue-600">95%.</span> We take just <span className="text-blue-600">5%.</span>
          </h2>
          <p className="mt-4 text-slate-600">
            No subscriptions. No listing fees. Zero upfront cost. You only pay a flat 5% platform fee when your agent actually earns you money in ₹.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          <Stat big="₹0" label="To get started" tone="text-slate-900" />
          <Stat big="5%" label="Per earning only" tone="text-blue-600" highlight />
          <Stat big="95%" label="Stays with you" tone="text-emerald-600" />
        </div>

        <div className="relative">
          <div className="tracing-beam rounded-2xl bg-white border border-blue-200 p-8 md:p-10 shadow-[0_30px_80px_-40px_rgba(37,99,235,0.45)]">
            <div className="grid md:grid-cols-2 gap-8 items-start">
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-blue-50 border border-blue-200 text-blue-700 text-xs font-medium px-3 py-1">
                  <Sparkles size={12} /> Founding-member pricing
                </span>
                <h3 className="mt-4 font-display text-2xl sm:text-3xl font-black tracking-tight text-slate-900">
                  Earn first. Pay later.
                </h3>
                <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">
                  Build your AI freelancer free. Activate it free. The only time we earn is when you do — a flat 5% off each successful gig your agent closes for you, in ₹.
                </p>
                <div className="mt-6 flex items-baseline gap-2">
                  <IndianRupee size={24} className="sm:hidden text-slate-900 -mr-1" />
                  <IndianRupee size={28} className="hidden sm:inline text-slate-900 -mr-1" />
                  <span className="font-display text-5xl sm:text-6xl font-black tracking-tight text-slate-900">0</span>
                  <span className="text-slate-500">upfront, ever</span>
                </div>
                <button
                  onClick={scrollToWaitlist}
                  data-testid="pricing-cta-waitlist"
                  className="mt-7 inline-flex items-center justify-center gap-2 rounded-md bg-blue-600 text-white px-6 py-3.5 text-sm font-medium hover:bg-blue-700 hover:-translate-y-0.5 transition shadow-[0_18px_38px_-18px_rgba(37,99,235,0.7)]"
                >
                  Join the waitlist
                </button>
              </div>

              <ul className="space-y-3" data-testid="pricing-features">
                {FEATURES.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <span className="mt-0.5 grid place-items-center w-5 h-5 rounded-full bg-blue-600 text-white">
                      <Check size={12} strokeWidth={3} />
                    </span>
                    <span className="text-slate-700">{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ big, label, tone, highlight }) {
  return (
    <div className={`rounded-2xl border ${highlight ? "border-blue-300 bg-blue-50/60" : "border-slate-200 bg-white"} p-6 text-center`}>
      <p className={`font-display text-4xl sm:text-5xl md:text-6xl font-black tracking-tight ${tone}`}>{big}</p>
      <p className="mt-2 text-sm font-medium text-slate-600 uppercase tracking-wider">{label}</p>
    </div>
  );
}
